// extracted by mini-css-extract-plugin
export var fadeInOut = "_26-3";
export var icon = "_26-4";
export var savedIndicator = "_26-2";
export var savingIndicator = "_26-0";
export var spin = "_26-1";